// extracted by mini-css-extract-plugin
export default {"HrConsultancyBG":"HrConsultancy_HrConsultancyBG__gsB9k"};